import React, { Component } from 'react';
import {connect} from 'react-redux';
import { getAllDemoQuestionByCategory, updateDemoCategory, emptyDemographicsCategories, softDeleteCategoryQuestion} from '../../actions/demographics';
import EditDemoCategories from '../../components/demographics/editDemoCategory';

class EditDemographicsCategories extends Component {
  constructor(props){
    super(props)
    this.state={
        editCategoryItem : "",
    };
    this.categoryList = this.categoryList.bind(this);
    this.updateDemoCategory = this.updateDemoCategory.bind(this);
    this.emptyDemographicsCategories = this.emptyDemographicsCategories.bind(this);
    this.gotoAddDemoQuestion = this.gotoAddDemoQuestion.bind(this);
    this.softDeleteCategoryQuestion = this.softDeleteCategoryQuestion.bind(this);
  }

  componentDidMount(){
 
    const { editCategoryItemData } = this.props.location.state;

    if(editCategoryItemData){
      let catId = editCategoryItemData.cat_id;
      this.props.dispatch(getAllDemoQuestionByCategory(catId));
        this.setState({
          editCategoryItem : editCategoryItemData
      });
    }
  }


  categoryList(){
    this.props.history.push('/demographicsCategories');
  }

  updateDemoCategory(data){
    this.props.dispatch(updateDemoCategory(data));
  }

  emptyDemographicsCategories(){
    this.props.dispatch(emptyDemographicsCategories())
  }

  gotoAddDemoQuestion(id){
    this.props.history.push('/addDemoCatQues/&c:'+id);
  }

  softDeleteCategoryQuestion(data){
    console.log(data);
    this.props.dispatch(softDeleteCategoryQuestion(data));
  }
  
  render(){
    let showEditDemographicsCategoriesView = "";
    if(this.state.editCategoryItem){
        showEditDemographicsCategoriesView = <EditDemoCategories
        editCategoryItem = {this.state.editCategoryItem}
        categoryList= {this.categoryList}
        demoGraphicsCategoriesQuesListSuccess = {this.props.demoGraphicsCategoriesQuesListSuccess}
        demoGraphicsCategoriesQuesListData = {this.props.demoGraphicsCategoriesQuesListData}
        updateDemoCategory = {this.updateDemoCategory}

        demoGraphicsCategoriesUpdateSuccess = {this.props.demoGraphicsCategoriesUpdateSuccess}
        demoGraphicsCategoriesUpdateSuccessMessage = {this.props.demoGraphicsCategoriesUpdateSuccessMessage}
        demoGraphicsCategoriesUpdateFailMessage = {this.props.demoGraphicsCategoriesUpdateFailMessage}

        emptyDemographicsCategories = {this.emptyDemographicsCategories}

        gotoAddDemoQuestion = {this.gotoAddDemoQuestion}
        softDeleteCategoryQuestion = {this.softDeleteCategoryQuestion}
        />
    }
    
      
    return (
        <div> 
             {showEditDemographicsCategoriesView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsCategoriesAddSuccess     : state.demographics.demoGraphicsCategoriesAddSuccess,
    demoGraphicsCategoriesResultData     : state.demographics.demoGraphicsCategoriesResultData,
    demoGraphicsCategoriesSuccessmessage : state.demographics.demoGraphicsCategoriesSuccessmessage,
    demoGraphicsCategoriesFailmessage    : state.demographics.demoGraphicsCategoriesFailmessage,

    demoGraphicsCategoriesQuesListSuccess : state.demographics.demoGraphicsCategoriesQuesListSuccess,
    demoGraphicsCategoriesQuesListData    : state.demographics.demoGraphicsCategoriesQuesListData,

    demoGraphicsCategoriesUpdateSuccess        : state.demographics.demoGraphicsCategoriesUpdateSuccess,
    demoGraphicsCategoriesUpdateSuccessMessage : state.demographics.demoGraphicsCategoriesUpdateSuccessMessage,
    demoGraphicsCategoriesUpdateFailMessage    : state.demographics.demoGraphicsCategoriesUpdateFailMessage
  }
}

export default connect(mapStateToProps)(EditDemographicsCategories);



// WEBPACK FOOTER //
// ./src/pages/demographics/editDemoCategory.js